<template>
    <div class="game-main" :style="{ height: mainHeight + 'px' }" v-loading="loading">
        <div class="game-main-content">
            <el-row>
                <game-header></game-header>
            </el-row>
            <el-row v-for="(item, index) in series" :key="index" class="game-series-row">
                <el-card :body-style="{ padding: '10px' }" shadow="always"
                    :class="['game-series', currentProductSeries === item.id ? 'game-series-selected' : '']">
                    <div @click="selectSeries(item.id)">
                        <img :src="item.image" class="responsive-img" style="height: 160px;" />
                        <div class="game-series-title">{{ item.name }}</div>
                    </div>
                    <el-row v-if="currentProductSeries === item.id">
                        <el-row :span="15" v-for="(item, index) in gameTypes" :key="index" style="padding: 5px">
                            <el-card :body-style="{ padding: '0px' }" shadow="hover">
                                <div class="game-type" @click="startGame(item)">
                                    <img :src="item.image" class="responsive-img" />
                                </div>
                            </el-card>
                        </el-row>
                    </el-row>
                </el-card>
            </el-row>
            <el-row>
                <game-footer></game-footer>
            </el-row>
        </div>
    </div>
</template>
<script>
import api from '@/utils/api'
import header from '../../components/game/head.vue'
import footer from '../../components/game/foot.vue'
// import VConsole from 'vconsole'
export default {
    components: {
        'game-header': header,
        'game-footer': footer
    },
    data () {
        return {
            loading: false,
            mainHeight: window.innerHeight,
            series: [
                { image: require('@/assets/images/game/game-series-128.png'), name: '128系列', id: 2 },
                { image: require('@/assets/images/game/game-series-168.png'), name: '168系列', id: 1 },
                { image: require('@/assets/images/game/game-series-1-1.png'), name: '1-1系列', id: 0 }
            ],
            gameTypes: [
                { image: require('@/assets/images/game/game-type-tlxxl.png'), type: '听力消消乐', index: 0, headerImg: 'game-head-tlxxl' },
                { image: require('@/assets/images/game/game-type-yyhyddp.png'), type: '英语汉语对对碰', index: 1, headerImg: 'game-head-yyhyddp' },
                { image: require('@/assets/images/game/game-type-dcpxdcg.png'), type: '单词拼写大闯关', index: 2, headerImg: 'game-head-dcpxdcg' },
                { image: require('@/assets/images/game/game-type-cjxxl.png'), type: '超级消消乐', index: 3, headerImg: 'game-head-cjxxl' }
            ],
            currentProductSeries: 2,
            currentGameType: {},
            productLevel: [0],
            headImg: 'game-head-main'
        }
    },
    created () {
        // this.currentGameType = this.gameTypes[0]
        this.gameTypes.orderby = (x) => x.index
        this.gameTypes = this.gameTypes.sort((a, b) => {
            return this.gameTypes.orderby(a) - this.gameTypes.orderby(b)
        })
        // const vConsole = new VConsole() // 初始化 vConsole
        // vConsole.hide() // 隐藏 vConsole 面板
        this.init()
    },
    methods: {
        init () {
            this.loading = true
            var code = this.$route.query.authCode
            var type = this.$route.query.series
            console.log('authCode from route:', code)
            if (!code) {
                code = localStorage.getItem('authCode')
            }
            if (!type) {
                type = localStorage.getItem('type')
            }
            if (code && type) {
                localStorage.setItem('authCode', code)
                localStorage.setItem('type', type)
                this.$axios.post(api.validateCodeForGame, { key: decodeURIComponent(code), type: type })
                    .then(res => {
                        if (res.data.result.state === 'success') {
                            for (let i = 0; i < this.series.length; i++) {
                                this.series[i] = { ...res.data.result.serieslist[0], ...this.series[i] }
                            }
                            this.series = this.series.filter(s => s.id === res.data.result.serieslist[0].id)
                            // console.log('this.series', this.series)
                            var item = this.series[0]
                            this.currentProductSeries = (item && item.id != null) ? item.id : 2
                            // console.log('this.currentProductSeries', this.currentProductSeries)
                            // console.log('this.productLevel', this.series.find(s => s.id === this.currentProductSeries))
                            var lv = this.series.find(s => s.id === this.currentProductSeries)
                            this.productLevel = (lv && lv.levelList) ? lv.levelList : [0, 1, 2]
                        } else {
                            this.series.splice(0, this.series.length)
                            this.$message({
                                message: '验证失败，无法加载游戏，请联系管理员'
                            })
                            // console.log('验证失败')
                        }
                        this.loading = false
                    })
                // return
            } else {
                this.loading = false
                // window.location.href = '/account/index'
            }
            // this.$axios.get('/api/AuthCode/getAuthCode', { params: { type: '168', account: '13801325083' } })
            //     .then(res => {
            //         if (res.data.result.state === 'success') {
            //             localStorage.setItem('authCode', res.data.result.token)
            //             console.log('authCode:', decodeURIComponent(res.data.result.token))
            //             this.$axios.post(api.validateCodeForGame, { key: decodeURIComponent(res.data.result.token), type: 168 })
            //                 .then(res => {
            //                     if (res.data.result.state === 'success') {
            //                         for (let i = 0; i < this.series.length; i++) {
            //                             this.series[i] = { ...res.data.result.serieslist[0], ...this.series[i] }
            //                         }

            //                         this.series = this.series.filter(s => s.id === res.data.result.serieslist[0].id)
            //                         console.log(this.series)
            //                         this.currentProductSeries = this.series[0].id || 2
            //                         this.productLevel = this.series.find(s => s.id === this.currentProductSeries).levelList || [0, 1, 2]
            //                     } else {
            //                         this.series.splice(0, this.series.length)
            //                         this.$message({
            //                             message: '验证失败，无法加载游戏，请联系管理员'
            //                         })
            //                         console.log('验证失败')
            //                     }
            //                     this.loading = false
            //                 })
            //         } else {
            //             this.$message({
            //                 message: '获取系列信息失败，请重试'
            //             })
            //             console.log('获取系列信息失败')
            //         }
            //     })
            // console.log('authCode from route:', encodeURIComponent('9HtM2V8MKbKipCs+TLjEkDSnlt++dxxFl1OpNJ6zzQ0='))
        },
        clearCookie (name, path = '/', domain) {
            // 覆盖 Cookie，设为过期
            document.cookie = `${encodeURIComponent(name)}=; 
                     expires=Thu, 01 Jan 1970 00:00:00 GMT; 
                     path=${path}; 
                     ${domain ? `domain=${domain};` : ''}
                     secure; 
                     SameSite=None`
        },
        startGame (gameType) {
            this.currentGameType = gameType
            this.headImg = this.currentGameType.headerImg || 'game-head-main'
            localStorage.setItem('headImg', this.headImg)

            if (this.currentGameType.type.indexOf('单词拼写大闯关') === -1 && this.currentGameType.type.indexOf('超级消消乐') === -1) {
                this.$router.push({ name: 'gsound', query: { series: this.currentProductSeries, productLevel: this.productLevel.join(','), gameType: this.currentGameType.type } })
            } else {
                this.$router.push({ name: 'gword', query: { series: this.currentProductSeries, productLevel: this.productLevel.join(','), gameType: this.currentGameType.type } })
            }
        },
        selectGame (game) {
            this.currentGameType = game
        },
        selectSeries (index) {
            this.currentProductSeries = index
        },
        handleCarouselChange (currentIndex) {
            this.currentProductSeries = currentIndex
        }
    }
}
</script>
<style scoped lang="less">
.game-main {
    padding: 15px;
    background-color: #f0f9ff;
    overflow-y: scroll;
}

.game-main-content {
    background-color: #fff;
    border-radius: 6px;
}

.game-type-selected {
    border-radius: 6px;
    background-color: #eae20a !important;
}

.game-type-selected .game-type-title,
.game-series-selected .game-series-title {
    color: #fff !important;
    font-size: 25px;
    font-weight: 700;
    padding: 0 10px 15px;
    font-style: italic;
}

.game-series-row {
    padding: 5px 0;
    text-align: center;
}

.game-type {
    width: 80%;
    margin: 0 auto;
    border-radius: 6px;
    vertical-align: middle;
    overflow: hidden;
    padding: 15px;
    // background-color: #409EFF;
}

.responsive-img {
    width: 100%;
    /* 宽度适应容器 */
    height: auto;
    /* 高度自动，保持比例 */

    display: block;
    /* 去除图片底部间隙 */
    object-fit: contain;
    /* 保持图片比例 */
    transition: transform 0.3s ease;
    /* 可选：图片裁剪填充（保持比例，可能裁切部分内容） */
    /* object-fit: contain; 可选：完整显示图片（可能留空白） */
}

.game-series-selected {
    border-radius: 6px;
    background-color: #eae20a;
}

.game-series {
    // width: 90%;
    overflow: hidden;
    margin: 5px auto;
}
</style>



// WEBPACK FOOTER //
// src/view/game/index.vue